import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Spinkit} from 'ng-http-loader/spinkits';
import {RouteConfigLoadEnd, RouteConfigLoadStart, Router} from '@angular/router';
import {SpinnerVisibilityService} from 'ng-http-loader/services/spinner-visibility.service';
import {AlertaService} from '@service/core/alerta.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  public spinkit = Spinkit;

  constructor (private router: Router,
               private spinner: SpinnerVisibilityService,
               public alerta: AlertaService
  ) {}

  ngOnInit () {
    this.router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart) {
        this.spinner.show();
      } else if (event instanceof RouteConfigLoadEnd) {
        this.spinner.hide();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts